import { Box, Typography, useTheme } from '@mui/material'
import { Trans, useTranslation } from 'react-i18next'
import BgImage from '../../../images/backgroundImage.png'

const IntroductionSection = () => {
  const theme = useTheme()
  const { t } = useTranslation()
  return (
    <Box
      sx={{
        backgroundImage: `url(${BgImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right',
        backgroundSize: 'cover',
      }}
    >
      <Box
        sx={{
          margin: '0 auto',
          maxWidth: '100rem',
          paddingTop: { xs: '3rem', md: '6rem' },
        }}
      >
        <Typography
          variant='h2'
          sx={{ mb: 2, color: 'publicPages.light' }}
          fontSize={{ xs: '2.5rem', md: '3.75rem' }}
          lineHeight={{ xs: '3rem', md: '4.5rem' }}
        >
          <Trans
            i18nKey='featuresPage.unlockSeamlessText'
            components={{
              highlight: <span style={{ color: theme?.palette?.primary?.main }} />,
            }}
          />
          <br />
          {t('featuresPage.exploreOurFeaturesText')}
        </Typography>
        <Box display='flex' flexDirection='column' alignItems='center'>
          <Typography
            variant='h2'
            sx={{ mb: '8.25rem', color: 'publicPages.main' }}
            fontSize={'1.25rem'}
            lineHeight={'1.875rem'}
            fontWeight={400}
            maxWidth={'35rem'}
          >
            {t('featuresPage.manageReservationsText')}
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}
export default IntroductionSection
